import { Link, useNavigate } from "react-router-dom";
import AuthTopBar from "../component/AuthTopBar";
import CustomiseYourAIExperience from "../../FreeTrail/components/CustomiseYourAIExperience";
import { useEffect, useState } from "react";
import ScaleYourAISolutions from "../../FreeTrail/components/ScaleYourAISolutions";
import BusinessDetails from "./BusinessDetails";
import { generateRandomID } from "../../../utils/generateRandomId";
import { useUsersContext } from "../../../context/usersContext";
import {
  useAgencySaasPlans,
  useCreateAccountAndActivateLocation,
  useCustomFields,
} from "../../../queries/auth";
import { useUserInfo } from "../../../context/user";
import { Toast } from "../../../components/Toast/Toast";

const AccountSetup = () => {
  const [type, setType] = useState("");
  const [step, setStep] = useState(0);
  const [inputs, setInputs] = useState({
    business_name: "",
    phone_number: "",
    team_size: "",
    business_type: "",
    customer_size: "",
  });
  const [agency_id, setAgencyId] = useState("");
  const {
    agency: whitelabel,
    isAgencySuccess: whitelabelSuccess,
    agencyError: whitelabelError,
  } = useUsersContext();
  const navigate = useNavigate();
  const logout = useUserInfo()[2];
  const saveActiveLocation = useUserInfo()[5];
  const userInfo = useUserInfo()[0];
  const updateUser = useUserInfo()[1];
  const [plan_id, setPlanId] = useState("");
  const [toast, setToast] = useState({
    message: "",
    type: "error",
    isVisible: false,
    subMessage: "",
  });

  useEffect(() => {
    if (whitelabelSuccess) {
      setAgencyId(whitelabel?._id);
    } else if (whitelabelError) {
      setAgencyId("6739f1be347a7f5974735cec");
    }
  }, [whitelabelSuccess, whitelabelError, whitelabel]);

  const { data: agencySaasData } = useAgencySaasPlans(agency_id);
  const products = agencySaasData?.success ? agencySaasData.data : [];

  const createAccountMutation = useCreateAccountAndActivateLocation();
  const loading = createAccountMutation.isPending;
  const customFieldsMutation = useCustomFields();

  const onTypeClick = (type) => {
    setType(type);
    HandleEveryStep(0);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const randomId = generateRandomID(20);
    const payload = {
      ...inputs,
      type: "premium",
      id: randomId,
      agency_id: agency_id,
      email: userInfo.email,
      plan_id: plan_id,
      account_type: type,
      userId: userInfo.userId,
    };
    createAccountMutation.mutate(
      { payload, userId: userInfo.userId },
      {
        onSuccess: ({ account, userUpdate }) => {
          if (userUpdate.success) updateUser(userUpdate.data);
          saveActiveLocation(account.data);
          setTimeout(() => { navigate("/onboarding"); }, 300);
        },
        onError: (error) => {
          setToast({
            message: error?.response?.data?.message || error.message,
            type: "error",
            subMessage: "Please try again",
            isVisible: true,
          });
          setTimeout(
            () =>
              setToast({
                message: "",
                type: "error",
                subMessage: "",
                isVisible: false,
              }),
            3000
          );
        },
      }
    );
  };

  const HandleEveryStep = (step) => {

    if (step === 0) {
      customFieldsMutation.mutate({
        userId: userInfo.userId,
        step: step,
      });
    } else if (step === 1) {
      customFieldsMutation.mutate({
        userId: userInfo.userId,
        step: step,
      });
    } else if (step === 2) {
      customFieldsMutation.mutate({
        userId: userInfo.userId,
        step: step,
      });
    } else {
      return;
    }
  }

  return (
    <div className="h-screen bg-background text-foreground">
      <AuthTopBar />
      <div className="relative flex justify-center">
        {/* <p className="text-[#757575] absolute top-7 right-12">
          Already have an account?{" "}
          <button
            className="text-[#1E1E1E]"
            onClick={() => {
              logout();
              navigate("/auth/sign-in");
            }}
          >
            Sign in
          </button>
        </p> */}
        <div className="text-center mt-14 w-full">
          {!type ? (
            <CustomiseYourAIExperience onTypeClick={onTypeClick} products={products} />
          ) : step === 0 ? (
            <ScaleYourAISolutions
              type={type}
              inputs={inputs}
              setInputs={setInputs}
              onNext={() => { setStep(1); HandleEveryStep(1); }}
              onBack={() => setType(null)}
            />
          ) : (
            <BusinessDetails
              inputs={inputs}
              setInputs={setInputs}
              loading={loading}
              handleSubmit={handleSubmit}
              onBack={() => setStep(0)}
            />
          )}
        </div>
      </div>
      <Toast
        duration={300}
        message={toast.message}
        subMessage={toast.subMessage ?? ""}
        type={toast.type}
        visible={toast.isVisible}
      />
    </div>
  );
};

export default AccountSetup;
